<template lang="">
    <v-card>
        <s-select-definition
            :def="1604"
            v-show="false"
            label="Sistemas SunExpert"
            @getDataInitial="getDataInitial($event)"
        />
        <s-crud
            :config="config"
            title="Dar de Baja a Usuarios"
            :filter="filter"
            search-input
            add
            edit
            remove
            @save="save($event)"
            ref="scrudUnsubscribe"
            @addEvent="addEvent($event)"
            @EditEvent="EditEvent($event)"
        >
            <template v-slot:filter>
                <v-container>
                    <v-row style="margin-bottom: 5px;">
                        <v-col cols="12" md="6">
                            <s-select-area
								label="Area"
								v-model="filter.AreID"
                                noDefault
                                full
                                clearable
							/>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:UsbAction="{ row }">
				<v-btn x-small color="error" @click="openModal(row, 2)" class="mr-1">
					<i class="fas fa-user-slash"></i> Deshabilitar
				</v-btn>
				<v-btn x-small color="success" @click="openModal(row, 1)">
					<i class="fas fa-user-check"></i> Habilitar
				</v-btn>
			</template>
            <template v-slot="props">
                <v-container>
                    <v-row >
                        <v-col cols="12" md="4" class="d-flex align-end">
                            <sToolbarPerson
                                v-if="!itemSave.UsbID || noEdit"
                                noCamera
                                noEdit
                                @returnPerson="returnPerson($event)"
                                v-model="props.item.PrsDocumentNumber"
                                label="DNI"
                                class="flex-grow-1"
                            />
                            <s-text
                                v-else
                                label="DNI"
                                v-model="itemSave.PrsDocumentNumber"
                                readonly
                                class="flex-grow-1"
                            />
                            <v-btn v-if="itemSave.UsbID" small color="primary" @click="noEdit = !noEdit" class="ml-2">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="8">
                            <s-text
                                label="Nombre"
                                v-model="itemSave.NtpFullName"
                                readonly
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                            v-for="(def, index) in definitions"
                            :key="index"
                            cols="12"
                            md="3"
                            class="s-col-form"
                        >
                            <s-text
                                :label="def.DedDescription"
                                v-model="itemSave[def.DedHelper]"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </s-crud>

        <!-- Modal de confirmación -->
        <v-dialog v-model="dialog" max-width="600">
            <v-card>
                <v-card-title class="headline">
                    <v-icon :color="typeUnsubscribe === 2 ? 'error' : 'success'" class="mr-2">
                        {{ typeUnsubscribe === 2 ? 'mdi-account-off' : 'mdi-account-check' }}
                    </v-icon>
                    {{ typeUnsubscribe === 2 ? 'Deshabilitar' : 'Habilitar' }} Usuario
                </v-card-title>
                
                <v-card-text>
                    <v-alert 
                        :type="typeUnsubscribe === 2 ? 'warning' : 'info'" 
                        text 
                        dense
                        class="mb-4"
                    >
                        {{ typeUnsubscribe === 2 
                            ? 'Selecciona los sistemas que deseas DESHABILITAR para este usuario' 
                            : 'Selecciona los sistemas que deseas HABILITAR para este usuario' 
                        }}
                    </v-alert>

                    <div class="mb-3">
                        <strong>Usuario:</strong> {{ selectedItem.NtpFullName }}
                    </div>

                    <v-divider class="mb-4"></v-divider>

                    <div>
                        <v-checkbox
                            v-for="(def, index) in definitions"
                            :key="index"
                            v-model="selectedSystems[def.DedHelper]"
                            :label="def.DedDescription"
                            hide-details
                            dense
                            class="mt-2"
                        ></v-checkbox>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeModal">
                        Cancelar
                    </v-btn>
                    <v-btn 
                        :color="typeUnsubscribe === 2 ? 'error' : 'success'" 
                        @click="confirmUnsubscribe"
                        :loading="loading"
                    >
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import UnsubscribeService from "../../services/InformationTechnology/UnsubscribeService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import SText from '../../components/Utils/SText.vue';

export default {
    components: {
        sToolbarPerson,
        SText
    },
    data() {
        return {
            noEdit: true,
            filter: {
                AreID: null,
            },
            config: {
                service: UnsubscribeService,
                model: {
                    UsbID: "ID",
                },
                headers: [
                    { text: "ID", value: "UsbID" },
                    { text: "Nombre", value: "NtpFullName" },
                    { text: "Accion", value: "UsbAction" },
                ]
            },
            definitions: [],
            itemSave: {
                NtpFullName: null,
                PrsDocumentNumber: null
            },
            // Nuevas propiedades para el modal
            dialog: false,
            selectedItem: {},
            selectedSystems: {},
            typeUnsubscribe: 2, // 1 = Habilitar, 2 = Deshabilitar
            loading: false
        }
    },
    methods: {
        save(item){
            Object.assign(item, this.itemSave);
            item.save();
        },
        returnPerson(data) {
            if (data) {
                console.log(data);
                this.itemSave.PrsDocumentNumber = data.PrsDocumentNumber;
                this.itemSave.NtpFullName = data.NtpFullName;
                this.itemSave.NtpID = data.NtpID;
                this.itemSave.CtrID = data.CtrID;
                this.itemSave.UsbSunExpert = data.UserSunExpertYSigrehu;
                this.itemSave.UsbSigrehu = data.UserSunExpertYSigrehu;
                this.itemSave.UsbSAP = data.UserSAP;
                this.itemSave.UsbScire = data.UserScire;
                this.itemSave.UsbWindows = data.UserWindows;
                this.itemSave.UsbEmail = data.UserEmail;
                this.itemSave.UsbAriSunshine = data.PrsDocumentNumber;
                this.itemSave.UsbSunshineCRM = data.UserSunshineCRM;
            }
        },
        getDataInitial(items) {
            console.log(items);
            this.definitions = items;

            // Quitamos los headers dinámicos previos
            this.config.headers = this.config.headers.filter(h => !h.dynamic);

            // Generamos nuevos headers dinámicos
            const dynamicHeaders = items.map(def => ({
                text: def.DedDescription,
                value: def.DedHelper,
                dynamic: true
            }));

            // Buscamos la posición de la columna "Accion" para insertar antes
            const indexAction = this.config.headers.findIndex(h => h.value === 'UsbAction');

            if (indexAction !== -1) {
                this.config.headers.splice(indexAction, 0, ...dynamicHeaders);
            } else {
                this.config.headers.push(...dynamicHeaders);
            }
        },
        openModal(item, type) {
            this.selectedItem = { ...item };
            this.typeUnsubscribe = type;
            
            // Inicializamos selectedSystems con todos los sistemas marcados por defecto
            this.selectedSystems = {};
            this.definitions.forEach(def => {
                this.selectedSystems[def.DedHelper] = true;
            });
            
            this.dialog = true;
        },
        closeModal() {
            this.dialog = false;
            this.selectedItem = {};
            this.selectedSystems = {};
        },
        async confirmUnsubscribe() {
            this.loading = true;
            
            try {
                // Construimos el objeto a enviar
                const obj = {
                    UsbID: this.selectedItem.UsbID,
                    UsrCreateID: this.$fun.getUserID(),
                    TypeUnsubscribe: this.typeUnsubscribe
                };

                // Agregamos los valores de los sistemas
                this.definitions.forEach(def => {
                    const helper = def.DedHelper;
                    // Si está marcado, enviamos el valor del item, sino null
                    obj[helper] = this.selectedSystems[helper] 
                        ? this.selectedItem[helper] 
                        : null;
                });

                console.log('Objeto a enviar:', obj);

                // Enviamos al servicio
                const response = await UnsubscribeService.list(obj, this.$fun.getUserID());
                
                console.log('Respuesta:', response);

                // Mostramos mensaje de éxito
                this.$fun.alert(`${this.typeUnsubscribe === 2 ? 'Deshabilitado' : 'Habilitado'} Correctamente`, 'success');

                this.closeModal();
            } catch (error) {
                console.error('Error:', error);
            } finally {
                this.loading = false;
            }
        },
        addEvent(item) {
            this.noEdit = true;
            this.itemSave = {
                NtpFullName: null,
                PrsDocumentNumber: null
            }
        },
        EditEvent(item) {
            console.log(item);
            this.noEdit = false;
            this.itemSave = {...item[0]};
        }
    }
}
</script>

<style scoped>
.v-input--checkbox {
    margin-top: 0 !important;
}
</style>